export enum CurrencyRestrictionsType {
	SET_CURRENCY_RESTRICTIONS = 'SET_CURRENCY_RESTRICTIONS',
}

export enum CurrencyRestrictionsActionsEnum {
	WALLET = 'WALLET',
	DEPOSIT = 'DEPOSIT',
	WITHDRAWAL = 'WITHDRAWAL',
	EXCHANGE = 'EXCHANGE',
	MERCHANTS = 'MERCHANTS',
}

export interface CurrencyRestrictions {
	currencyCode: string;
	enabledActions: CurrencyRestrictionsActionsEnum[];
	isRestricted: boolean;
	restrictedNetworks: string[];
}

export interface SetCurrencyRestrictionsAction {
	type: typeof CurrencyRestrictionsType.SET_CURRENCY_RESTRICTIONS;
	data: CurrencyRestrictions[];
}
